import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RequestInformationFatturaPaLpComponent } from './request-information-fattura-pa-lp';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.request-information-fattura-pa-lp', {
            url: '/request-information-fattura-pa-lp',
            ncyBreadcrumb: {
                label: 'Richiesta Informazioni Fattura Elettronica LP',
                parent: 'home.fatturazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Richiesta Informazioni Fattura Elettronica LP'
            },
            'views': {
                'homeContent': {
                    template: '<request-information-fattura-pa-lp flex="100"></request-information-fattura-pa-lp>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RequestInformationFatturaPaLpModule: string = ng
    .module('request-information-fattura-pa-lp', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('requestInformationFatturaPaLp', RequestInformationFatturaPaLpComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/request-information-fattura-pa-lp/request-information-fattura-pa-lp.module.ts